import AuditReport from "../../../jsx/components/Dashboard/AuditReport/AuditReport";

const AuditReportWrapper = () => {
  return <AuditReport />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];
export default constore(AuditReportWrapper);
